import { useSelector } from 'react-redux';

const useIsInfluencer = () => {
  const role = useSelector(state => state.auth.currentUser.role);
  return role === 'influencer';
};

export default useIsInfluencer;
